// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#contentContainer {
    align-content: center;
    width: 25%;
    height: 100%;
}

#tableDesign {
    font-family: Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
    scroll-behavior:auto;
}


#tableDesign tr:nth-child(even) {
    background-color: #f2f2f2;
}

#tableDesign tr:hover {
    background-color: #ddd;
}

    #tableDesign th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #060606;
        color: white;
    }


#tableDesign td, #tableDesign th {
    border: 1px solid #ddd;
    padding: 8px;
}

#exportButton {
    color: white;
    background-color: #3e6997;
    border: 0px;
    width: 100px;
    height: 30px;
    border-radius: 5px;
    float: right
}

.center {
  margin-left: auto;
  margin-right: auto;
}

.checked-row {
    background-color: #b6f5c0;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;IACzB,WAAW;IACX,oBAAoB;AACxB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;IAEI;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;QAChB,yBAAyB;QACzB,YAAY;IAChB;;;AAGJ;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n#contentContainer {\n    align-content: center;\n    width: 25%;\n    height: 100%;\n}\n\n#tableDesign {\n    font-family: Arial, Helvetica, sans-serif;\n    border-collapse: collapse;\n    width: 100%;\n    scroll-behavior:auto;\n}\n\n\n#tableDesign tr:nth-child(even) {\n    background-color: #f2f2f2;\n}\n\n#tableDesign tr:hover {\n    background-color: #ddd;\n}\n\n    #tableDesign th {\n        padding-top: 12px;\n        padding-bottom: 12px;\n        text-align: left;\n        background-color: #060606;\n        color: white;\n    }\n\n\n#tableDesign td, #tableDesign th {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\n#exportButton {\n    color: white;\n    background-color: #3e6997;\n    border: 0px;\n    width: 100px;\n    height: 30px;\n    border-radius: 5px;\n    float: right\n}\n\n.center {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.checked-row {\n    background-color: #b6f5c0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
